import { create } from 'zustand';

export interface IssueDrawerTarget {
  orgId: string;
  orgSlug: string;
  projectKey: string;
  issueKey: string;
}

interface IssueDrawerState {
  target: IssueDrawerTarget | null;
  open: (target: IssueDrawerTarget) => void;
  close: () => void;
}

export const useIssueDrawerStore = create<IssueDrawerState>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));
